import type { AgendaConsultant } from "./agendaTypes";

export function isConsultantRole(role: string | null | undefined): boolean {
  return role?.trim().toLowerCase() === "consultant";
}

export function resolveConsultantProfile(
  user: { id: number; first_name: string },
  consultants: AgendaConsultant[]
): AgendaConsultant {
  const fromDay = consultants.find((entry) => entry.id === user.id);
  if (fromDay) {
    return fromDay;
  }

  return {
    id: user.id,
    first_name: user.first_name,
    city: "",
  };
}
